var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('h2',{staticClass:"text-h4"},[_vm._v(" Ebook legal rol ACM ")])]),_c('v-col',{attrs:{"cols":"12"}},[_c('FileLegalList')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }